import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
} from "@mui/material";
import FeetForm from "./FeetForm";
import { useForm } from "react-hook-form";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Overview } from "./Overview";
import PatientDataForm from "./PatientDataForm";
import TherapyForm from "./TherapyForm";
import { useTranslation } from "react-i18next";
import { useCreatePatient, useEditPatientData } from "../../api/ekoApi";
//import Logo from '../assets/ekologo.png'



function StepperHorizontal({ patientData, edit=false }) {
  //console.log(patientData?.data, 'patientData')
  const { handleSubmit, control, watch, setValue, trigger } = useForm();
  const { t } = useTranslation();
  const steps = [t("patientGeneralData"), t('feetMeasurement'), t('overview'), t('therapy')];
  const [activeStep, setActiveStep] = useState(0);
  const createPatient = useCreatePatient()
  const editPatient = useEditPatientData()
  const navigate = useNavigate();
  
  const personalData = watch(); // Get all form data using watch()

  useEffect(() => {
    if (patientData && patientData.data) {
      Object.keys(patientData.data).forEach((key) => {
        // Check if the value is a date field
        if (key === 'birthdate' || key === 'examinationdate' || key === 'checkdate1' || key === 'checkdate2' || key === 'checkdate3' || key === 'serialNumberDate' || key === 'createdAt' || key === 'updatedAt') {
          // Parse the date string to JavaScript Date object
          const dateValue = new Date(patientData.data[key]);
          // Check if the parsed date is valid
          if (!isNaN(dateValue.getTime())) {
            setValue(key, dateValue);
          } else {
            console.error(`Invalid date value for ${key}: ${patientData.data[key]}`);
          }
        } else {
          // For other fields, directly set the value
          setValue(key, patientData.data[key]);
        }
      });
    }
  }, [patientData, setValue]);

  const handleNext = async () => {
    // Trigger validation for the entire form
    const isValid = await trigger();

    if (isValid) {
      // Proceed to the next step if form is valid
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const onSubmit = (data) => {
    if (activeStep === steps.length) {
      // Log form data only on the last step
      //console.log("Final Form Data:", data);
    }
    if (activeStep === 0) {
      // Form data from the first step
      //console.log("Personal Data:", data);
    } else if (activeStep === 1) {
      // Form data from the second step
      //console.log("Feet Data:", data);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleOpenReport = () => {
    if (edit) {
        editPatient.mutate({ id: personalData._id, dataToEdit: personalData }, {
            onSuccess: (responseData) => {
              //console.log(responseData.data)
                navigate('/report', { state: { personalData } });
            }
        });
    } else {
        createPatient.mutate(personalData, {
            onSuccess: (responseData) => {
                navigate('/report', { state: { personalData: responseData } });
            }
        });
    }
}

  console.log(personalData)

  return (
    <Box sx={{ width: "100%" }} p={5}>
      <Stepper
        activeStep={activeStep}
        sx={{
          width: "100%",
          backgroundColor: "#f6f6f6",
          borderRadius: "10px",
        }}
      >
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          return (
            <Step key={label} {...stepProps}>
              <StepLabel {...labelProps}>{label}</StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
           {t('allStepsAreDone')}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "row", pt: 2, justifyContent: 'center' }}>
            
            <Button onClick={handleOpenReport} variant="contained">{edit ? t('editPatient') : t('saveAndOpenReport')}</Button>
            <Button onClick={handleReset}>{t('backToPatientsList')}</Button>
         </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div>
              <form onSubmit={handleSubmit(onSubmit)}>
                {activeStep === 0 && <PatientDataForm control={control} />}
                {activeStep === 1 && <FeetForm control={control} />}
                {activeStep === 2 && <Overview personalData={personalData} />}
                {activeStep === 3 && <TherapyForm control={control} personalData={personalData}/> }
                <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
                  <Button
                    color="inherit"
                    disabled={activeStep === 0}
                    onClick={handleBack}
                    sx={{ mr: 1 }}
                  >
                    {t('back')}
                  </Button>
                  <Box sx={{ flex: "1 1 auto" }} />
                  <Button
                    type="button"
                    onClick={handleNext}
                    // Enable Next for the "Overview" step
                  >
                    {activeStep === steps.length - 1  ? t('finish') : t('next')}
                  </Button>
                </Box>
              </form>
            </div>
          </LocalizationProvider>
        </React.Fragment>
      )}
    </Box>
  );
}

export { StepperHorizontal };
